import { getRouteApi } from "@tanstack/react-router";
import { AppIcon, Button, Plate } from "@wilco/ui";
import { useEffect } from "react";
import { LOGIN_URL } from "../auth.ts";
import { serverErrorText, t } from "../i18n.ts";

const route = getRouteApi("/login");

/**
 * Вход только через Google (ADR-0007). Кнопка ведёт на сервер, он уводит на
 * Google и возвращает с сессией; отказ приходит кодом в ?error.
 */
export function LoginPage() {
  const { error, out } = route.useSearch();
  // Незнакомый код (invalid_id_token от Spring Security) даёт общий текст.
  const message = error ? (serverErrorText(error) ?? t("login.error.retry")) : undefined;

  useEffect(() => {
    document.title = t("app.title", { page: t("login.title") });
  }, []);

  return (
    <main className="login">
      <Plate cut="lg" className="login-plate w-fade-in">
        <AppIcon name="overview" size={56} />
        <h1 className="login-title">{t("login.title")}</h1>
        <p className="w-muted">{t("login.lead")}</p>
        {message ? (
          <div className="login-error" role="alert">
            <strong>{t("login.error.title")}</strong>
            <span>{message}</span>
          </div>
        ) : null}
        {out && !message ? (
          <p className="login-note" role="status">
            {t("login.signedOut")}
          </p>
        ) : null}
        {/* Обычная ссылка, а не fetch: OAuth это переход страницы. */}
        <Button asChild variant="primary" size="lg" block>
          <a href={LOGIN_URL}>{t("login.google")}</a>
        </Button>
      </Plate>
    </main>
  );
}
